import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrlPipe } from '../../pipes/safe-url.pipe';

@Component({
  selector: 'e360-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss'],
  standalone: true,
  imports: [SafeUrlPipe]
})
export class IframeComponent {
  frameSource: string = '';

  constructor(private route: ActivatedRoute) {
    this.route.data.subscribe((data: { frameSource: string }) => {
      this.frameSource = data.frameSource;
    });
  }
}
